module.exports = __webpack_public_path__ + "media/images/icons/play-50edb1f0d313d4c33597eea936ec4649.svg";